import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable()
export class AuthGuard {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate() {
    if (this.auth.isAuthenticated) {
      return true;
    } else {
      this.router.navigateByUrl('/auth/login');
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/guards/auth-guard.service.ts